import {
  Box,
  Chip,
  FormLabel,
  Autocomplete,
  TextField,
  Checkbox,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SelectGroupFanpage = ({
  selected_group_fanpages, // Đây nên là mảng các ID: [1, 2, 3]
  onSelectGroupFanpageChange,
  list_group_fanpage,
}) => {
  const { t } = useTranslation();

  // Chuyển đổi ID list thành Object list để Autocomplete hiểu được
  const selectedOptions = list_group_fanpage.filter(item => 
    selected_group_fanpages.includes(item.id)
  );

  return (
    <Box sx={{ mt: 3 }}>
      <FormLabel
        component="legend"
        sx={{
          fontWeight: "bold",
          fontSize: "1.1rem",
          mb: 1,
          color: "rgba(0, 0, 0, 0.87)",
        }}
      >
        {t("Áp dụng cho nhóm Fanpage:")}
      </FormLabel>

      <Autocomplete
        multiple
        size="small"
        id="search-select-group-fanpage"
        options={list_group_fanpage}
        disableCloseOnSelect
        // Chế độ tìm kiếm: tìm theo tên nhóm
        getOptionLabel={(option) => t("post.group") + " " + (option.name || "")}
        
        // So sánh giá trị để xác định item đã chọn
        isOptionEqualToValue={(option, value) => option.id === value.id}
        
        value={selectedOptions}
        
        onChange={(event, newValue) => {
          // Trả về mảng các ID cho component cha
          onSelectGroupFanpageChange(newValue.map(item => item.id));
        }}

        // Render danh sách có checkbox bên cạnh để dễ nhìn
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {t("post.group") + " " + option.name}
          </li>
        )}

        // Render ô input để search
        renderInput={(params) => (
          <TextField 
            {...params} 
            placeholder={selected_group_fanpages.length === 0 ? t("post.selectPageGroup") : ""} 
          />
        )}

        // Render các tag (Chip) khi đã chọn
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              label={t("post.group") + " " + option.name}
              size="small"
              {...getTagProps({ index })}
            />
          ))
        }
        
        // CSS để hiển thị đẹp hơn
        sx={{
          "& .MuiOutlinedInput-root": {
            padding: "3px 9px",
          },
        }}
      />
    </Box>
  );
};

export default SelectGroupFanpage;